import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { ProductCategory } from 'app/views/campaign-3/models/campaign-3.model';

@Component({
  selector: 'app-campaign-3-search-categories',
  templateUrl: './campaign-3-search-categories.component.html',
  styleUrls: ['./campaign-3-search-categories.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchCategoriesComponent implements OnInit {
  
  @Input() categoriesList: Array<any> = [];
  
  @Output() categoriesListSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() categoriesListCancel: EventEmitter<boolean> = new EventEmitter<boolean>();

  listCategoriesSelected: Array<any> = [];
  paginationType: number = Campaign3KontableComponent.NoPagination;
  
  paniereListCopy: Array<any> = [];

  show = {
    table: false
  }

  categoryTree: ProductCategory[] = []; // Array di categorie di livello 0 con relative categorie figlie
  
  constructor() {}

ngOnInit() {
  this.listCategoriesSelected = []; // resetta la lista all’inizio

  // Recupera le selezioni precedenti
  for(let cat of this.categoriesList){
    if(cat.rowSelected){
      this.listCategoriesSelected.push(cat); // usa direttamente l’oggetto
    }
  }

  this.sortLevelCategories(); // Ordina le categorie in base al livello
  this.buildCategoryTree();   // Costruisci l’albero delle categorie
  this.setSelectedCategoriesInTree(this.categoryTree, this.listCategoriesSelected);

  this.show.table = true;
}

  resetSelected(){
    for(let cat of this.categoriesList){
      cat["rowSelected"]=false;
    }
  }
  // Funzione per ordinare le categorie in base al livello
  sortLevelCategories() {
    this.categoriesList.sort((a, b) => a.level_no - b.level_no);
  }
  setSelectedCategoriesInTree(tree: ProductCategory[], selectedCategories: any[]): void {
    const setSelectedRecursive = (categories: ProductCategory[]) => {
      for (const category of categories) {
        if (selectedCategories.some(selectedCat => selectedCat.id === category.id)) {
          category["rowSelected"] = true;
        }
        if (category.children) {
          setSelectedRecursive(category.children); // Chiamata ricorsiva per esplorare i figli
        }
      }
    };
  
    setSelectedRecursive(tree); // Avvia la ricorsione dall'albero radice
  }
buildCategoryTree(): void {
  const categoryMap = new Map<number, ProductCategory>();
  const rootCategories: ProductCategory[] = [];

  // Pulisci eventuali children residui
  this.categoriesList.forEach(cat => cat.children = []);

  // Costruisci l’albero
  this.categoriesList.forEach(category => {
    category.rowSelected = this.listCategoriesSelected.some(x => x.id === category.id);

    const parentId = category.parent_id;

    if (parentId) {
      const parentCategory = categoryMap.get(parentId);
      if (parentCategory) {
        parentCategory.children.push(category);
      }
    } else {
      rootCategories.push(category);
    }

    categoryMap.set(category.id, category);
  });

  // Aggiorna i livelli
  const updateLevels = (categories: ProductCategory[], level: number) => {
    categories.forEach(category => {
      category.level_count = level;
      if (category.children) {
        updateLevels(category.children, level + 1);
      }
    });
  };
  updateLevels(rootCategories, 1);

  this.categoryTree = rootCategories;
}


  onSelectedCategory(cat: any){
   
    let indexInSelected = this.listCategoriesSelected.findIndex(x=>x.id == cat.id);
    if(!cat.rowSelected){
      if(indexInSelected>-1) this.listCategoriesSelected.splice(indexInSelected,1);
    }
    else if(cat.rowSelected){
      if(indexInSelected==-1) this.listCategoriesSelected.push(cat);
    }
  }
  onClickAddCategories(){
 
    if(this.listCategoriesSelected && this.listCategoriesSelected.length>0){
      this.categoriesListSelected.emit(this.listCategoriesSelected);
    }
    else{
      this.categoriesListSelected.emit(null);
    }
  }
  onClickCancelCategories(){
    this.categoriesListCancel.emit(true);
  }
  filterByCodeDescription(searchTerm: string, categories: ProductCategory[] = this.categoryTree): ProductCategory[] {
    let result: ProductCategory[] = [];
  
    categories.forEach(category => {
      if (category.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
          category.description.toLowerCase().includes(searchTerm.toLowerCase())) {
        result.push(category); // Se la categoria corrente corrisponde al criterio di ricerca, aggiungila ai risultati
      }
  
      if (category.children) {
        const childResult = this.filterByCodeDescription(searchTerm, category.children); // Chiamata ricorsiva per esplorare i figli
        if (childResult.length > 0) {
          result = result.concat(childResult); // Concatena i risultati della ricerca nei figli al risultato corrente
        }
      }
    });
  
    return result;
  }
  toggleCategory(category: ProductCategory): void {
    category.expanded = !category.expanded; // Cambia lo stato di espansione/contrazione della categoria
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-categories/campaign-3-search-categories.component.ts